// extracted by mini-css-extract-plugin
export var container = "_da-0";
export var popoverContent = "_da-1";
export var tosLink = "_da-2";